<template>
    <div>
        <el-table
            :data="formData.filter(data => !search || data.pname.toLowerCase().includes(search.toLowerCase()))"
            border
            fit
            :max-height="360"
            style="width: 100%"
            @cell-click="editCell"
        >
            <el-table-column align="center" label="操作" width="180" v-if="!autoAdd">
                <template slot-scope="{ row }">
                    <el-button
                        icon="el-icon-plus"
                        size="mini"
                        circle
                        @click="addRow(row)"
                    />
                    <el-button
                        v-if="row.pid>0"
                        icon="el-icon-document-copy"
                        size="mini"
                        type="primary"
                        circle
                        @click="copyRow(row)"
                    />
                    <el-button
                        icon="el-icon-delete"
                        size="mini"
                        type="danger"
                        circle
                        @click="removeRow(row)"
                    />
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
                <el-table-column
                    :key="index"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align"
                    :min-width="col.min_width"
                    v-if="!col.hide"
                >
                    <template #header v-if="col.type === 'whEdit'">
                        {{col.label}}
                        <el-dropdown @command="changeDropItem($event,col)" style="padding-right:20px">
                            <span class="ddname">
                                批量
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="wh in wList"
                                    :key ="wh.id"
                                    :command="wh.id"
                                >{{wh.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                    <template #header v-else-if="col.type === 'sproductEdit'">
                        <el-input v-model="search" placeholder="输入筛选产品"></el-input>
                    </template>
                    <template slot-scope="{ row }">
                        <template v-if="col.edit">
                            <template v-if="col.type === 'productEdit'">
                                <template v-if="row[col.edit]">
                                    <el-select
                                        ref="editCell"
                                        v-model="row.pname"
                                        placeholder="请输入商品编号或商品名称"
                                        filterable
                                        style="width: 100%"
                                        @change="chooseSpecs($event, row)"
                                        @blur="cancel(row, col.edit)"
                                    >
                                        <el-row
                                            style="
                                                width: 600px;
                                                height: 40px;
                                                line-height: 40px;
                                                background: #d6d7d9;
                                            "
                                        >
                                            <el-col
                                                :span="5"
                                                :offset="2"
                                                style="
                                                    font-size: 14px;
                                                    text-align: left;
                                                "
                                                >商品编号</el-col
                                            >
                                            <el-col
                                                :span="9"
                                                style="
                                                    font-size: 14px;
                                                    text-align: left;
                                                "
                                                >商品名称</el-col
                                            >
                                            <el-col
                                                :span="3"
                                                style="
                                                    font-size: 14px;
                                                    text-align: left;
                                                "
                                                >颜色</el-col
                                            >
                                            <el-col
                                                :span="3"
                                                style="
                                                    font-size: 14px;
                                                    text-align: left;
                                                "
                                                >尺码</el-col
                                            >
                                        </el-row>
                                        <el-option
                                            v-for="(
                                                item, index1
                                            ) in productList"
                                            :key="index1"
                                            :label="
                                                item.number +
                                                ' ' +
                                                item.name +
                                                (item.color !== ''
                                                    ? '_' + item.color
                                                    : '') +
                                                (item.size !== ''
                                                    ? '_' + item.size
                                                    : '')
                                            "
                                            :value="item"
                                            style="
                                                width: 600px;
                                                height: 40px;
                                                padding: 0;
                                            "
                                        >
                                            <el-row
                                                style="
                                                    width: 600px;
                                                    height: 40px;
                                                    line-height: 40px;
                                                "
                                            >
                                                <el-col
                                                    :span="5"
                                                    :offset="2"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                >
                                                    {{ item.number }}
                                                </el-col>
                                                <el-col
                                                    :span="9"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                >
                                                    {{ item.name }}
                                                </el-col>
                                                <el-col
                                                    :span="3"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                >
                                                    {{ item.color }}
                                                </el-col>
                                                <el-col
                                                    :span="3"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                >
                                                    {{ item.size }}
                                                </el-col>
                                            </el-row>
                                        </el-option>
                                    </el-select>
                                    <span
                                        class="productList"
                                        @click="productMany(row)"
                                        ><i class="el-icon-more"
                                    /></span>
                                </template>
                                <span v-else>{{ row[col.prop] }}</span>
                            </template>
                            <template v-else-if="col.type === 'mproductEdit'">
                                <template v-if="row[col.edit]">
                                    <el-select
                                        ref="editCell"
                                        v-model="row.pname"
                                        filterable
                                        style="width: 100%"
                                        @change="chooseMSpecs($event, row)"
                                        @blur="cancel(row, col.edit)"
                                    >
                                        <el-option
                                            v-for="(item, index1) in mpList"
                                            :key="index1"
                                            :label="item.number +' ' +item.name +item.spec"
                                            :value="item"
                                        >
                                        </el-option>
                                    </el-select>
                                </template>
                                <span v-else>{{ row[col.prop] }}</span>
                            </template>
                            <template v-else-if="col.type === 'countEdit'">
                                <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkNumber($event,row,col.prop)" @blur="row[col.edit]=false">
                                    <span slot="suffix" style="line-height: 40px;">{{col.unit?col.unit:''}}</span>
                                </el-input>
                                <span v-else>{{row[col.prop]+(col.unit?col.unit:'')}}</span>
                            </template>
                            <template v-else-if="col.type === 'unknowNumEdit'">
                                <div v-if="row.inter==1">
                                    <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkNumber($event,row,col.prop)" @blur="row[col.edit]=false">
                                    </el-input>
                                    <span v-else>{{row[col.prop]}}</span>
                                </div>
                                <div v-else>
                                    <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkMoney($event,row,col.prop)" @blur="row[col.edit]=false">
                                    </el-input>
                                    <span v-else>{{row[col.prop]}}</span>
                                </div>
                            </template>
                            <template v-else-if="col.type === 'priceEdit'">
                                <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkMoney($event,row,col.prop)" @blur="row[col.edit]=false">
                                </el-input>
                                <span v-else>{{row[col.prop]}}</span>
                            </template>
                            <template v-else-if="col.type === 'countLimitEdit'">
                                <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkMaxNumber($event,row,col.prop)" @blur="row[col.edit]=false">
                                    <span slot="suffix" style="line-height: 40px;">{{col.unit?col.unit:''}}</span>
                                </el-input>
                                <span v-else>{{row[col.prop]+(col.unit?col.unit:'')}}</span>
                            </template>
                            <template v-else-if="col.type === 'countCommonLimitEdit'">
                                
                            </template>
                            <template v-else-if="col.type === 'unknowNumCLEdit'">
                                <div v-if="row.inter==1">
                                    <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkCommonMaxNumber($event,row,col.prop,row[col.maxValue])" @blur="row[col.edit]=false">
                                    </el-input>
                                    <span v-else>{{row[col.prop]}}</span>
                                </div>
                                <div v-else>
                                    <el-input v-if="row[col.edit]" ref="editCell" v-model="row[col.prop]" @input="$common.checkCommonMaxMoney($event,row,col.prop,row[col.maxValue])" @blur="row[col.edit]=false">
                                    </el-input>
                                    <span v-else>{{row[col.prop]}}</span>
                                </div>
                            </template>
                            <template v-else-if="col.type === 'whEdit'">
                                <el-select v-if="row[col.edit]" v-model="row[col.prop]" @change="changeWh($event,row,col)">
                                    <el-option v-for="(item, index) in wList"
                                        :key="index"
                                        :value="item.id"
                                        :label="item.name"
                                    ></el-option>
                                </el-select>
                                <span v-else>{{row[col.showName]}}</span>
                            </template>
                            <template v-else-if="col.type === 'remarkEdit'">
                                <el-input v-if="row[col.edit]" ref="editCell" maxlength="50" v-model="row[col.prop]"  @blur="row[col.edit]=false"/>
                                <span v-else>{{row[col.prop]}}</span>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="col.type=='stockEdit'">
                                <span :class="{'errstyle':row.negative==0}">{{row.stDesc}}</span>
                            </template>
                            <template v-else-if="col.type=='unitEdit'">
                                <template>{{ row[col.prop]+$global.unit+'/'+$global.pack}}</template>
                            </template>
                            <template v-else-if="col.type=='tpriceEdit'">
                                <template>{{ (row[col.cal1]*row[col.cal2]).toFixed(2)}}</template>
                            </template>
                            <template v-else-if="col.type=='notSendEdit'">
                                <template><div class="red">{{ row[col.prop]}}</div></template>
                            </template>
                            <template v-else-if="col.type=='imgEdit'">
                                <template>
                                    <el-image
                                        style="width: 35px"
                                        :src="row.img"
                                    >
                                        <template #error>
                                            <div class="errorFonts_mini">暂无图片</div>
                                        </template>
                                    </el-image>
                                </template>
                            </template>
                            <template v-else>{{ row[col.prop] }}</template>
                        </template>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <el-dialog
            :visible.sync="productListDialog"
            title="商品列表"
            width="90%"
            v-loading="cload"
        >
            <ProductList ref="proList" @close="closeProductList(arguments)" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="proSelected">确认</el-button>
                <el-button @click="productListDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ProductList from "../../components/product/list.vue";
export default {
    components: {ProductList},
    props:{
        cols:{
            type:Array,
            default:function(){
                return [];
            }
        },
        structure:{
            type:Function,
            default:function(){
                return {};
            }
        },
        autoAdd:{
            type:Boolean,
            default:false,
        },
        productModel:{
            type:Boolean,
            default:true,
        },
        wareHouseModel:{
            type:Boolean,
            default:true,
        },
        mproductModel:{
            type:Boolean,
            default:false,
        }
    },
    data() {
		return {
            wList:[],
            productList:[],
            productListDialog:false,
            formData:[],
            maxCount:1,
            curRow:{},
            search:'',
            cload:false,
            mpList:[],
        }
    },
    mounted() {
        if(this.productModel){
            this.getProduct();
        }
        if(this.wareHouseModel){
            this.getWareHouse();
        }
        if(!this.mproductModel){
            if(!this.autoAdd){
                let obj = this.structure();
                this.formData.push(obj);
            }
        }
    },
    methods:{
        editCell(row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    row[col.edit] = !row[col.edit];
                }
                this.$nextTick(() => {
                    if (this.$refs.editCell && this.$refs.editCell.length > 0) {
                        this.$refs.editCell[0].focus();
                    }
                });
            });
        },
        addRow(row) {
            let index = this.getIndex(row);
            let obj = this.structure();
            obj.id = this.maxCount;
            if(index>=0){
                this.formData.splice(index+1, 0, obj);
            }else{
                this.formData.push(obj);
            }
            this.maxCount++;
            return obj;
        },
        copyRow(row){
            let obj = {};
            let arr = Object.keys(row);
            arr.forEach(e=>{
                if(e!='spkey'){
                    let val = row[e];
                    if(typeof(val)=='boolean'){
                        obj[e] = false;
                    }else{
                        obj[e] = val;
                    }
                }
            })
            let index = this.getIndex(row);
            obj.id = this.maxCount;
            if(index>=0){
                this.formData.splice(index+1, 0, obj);
            }else{
                this.formData.push(obj);
            }
            this.maxCount++;
            return obj;
        },
        clearAll(){
            this.formData = [];
            this.maxCount = 1;
        },
        removeRow(row){
            if(this.formData.length<1){
                return;
            }
            let index = this.getIndex(row);
            if(index>=0){
                this.formData.splice(index, 1);
            }
            if(this.formData.length==0){
                let obj = this.structure();
                this.formData.push(obj);
            }
        },
        getIndex(row){
            let id = row.id;
            for(let i=0;i<this.formData.length;i++){
                if(this.formData[i].id==id){
                    return i;
                }
            }
            return -1;
        },

        getData(){
            this.$emit('returnData',this.formData);
        },
        setData(res,callback){
            this.formData = [];
            this.maxCount = 1;
            res.forEach(e=>{
                let obj = this.structure();
                callback(obj,e);
                this.formData.push(obj);
            })
            if(!this.autoAdd){//如果可以手动添加的话，则id必须作为排序使用
                let index = 1;
                this.formData.forEach(e=>{
                    e.id = index;
                    index++;
                })
                this.maxCount = index;
            }
        },
        cancel(row,val){
            var t = setTimeout(()=>{
                row[val] = false;
            },100)
        },
        ////////////仓库相关/////////////
        changeWh(event,row,col){
            if(row.stockList[event]){
                row[col.showName] = row.stockList[event].name;
                if(col.main==1){
                    row.negative = row.stockList[event].negative;
                    row.stock = row.stockList[event].stock;
                    row.stDesc = row.stockList[event].stDesc;
                }
            }
            row[col.edit] = false;
        },

        getWareHouse(){
            this.$api.listWareHouse().then((res)=>{
                if(res.data.code==1){
                    res.data.data.forEach(e=>{
                        this.wList.push(e);
                    });
                }
            })
        },
        changeDropItem(s,col){
            this.formData.forEach(e=>{
                if(e.stockList[s]){
                    e[col.prop] = s;
                    e[col.showName] = e.stockList[s].name;
                    if(col.main==1){
                        e.stock = e.stockList[s].stock;
                        e.negative = e.stockList[s].negative;
                        e.stDesc = e.stockList[s].stDesc;
                    }
                }
            })
        },
        ///////////////采购产品///////////////////
        setMProduct(val,type){
            this.mpList = [];
            this.getMProduct(val,type,()=>{
                this.formData = [];
                let obj = this.structure();
                this.formData.push(obj);
            });
        },
        getMProduct(val,type,callback){
            if(type==1){
                this.$api.mListProduct({supply:val,limit:40}).then(res => {
                    if(res.data.code==1){
                        res.data.data.data.forEach(e => {
                            let obj = {
                                pid:e.id,
                                spid:e.sid,
                                number:e.number,
                                name:e.name,
                                price:e.price,
                                unit:e.packing,
                                inter:e.inter,
                                spec:"",
                                stocknum:e.amount,
                            }
                            this.mpList.push(obj);
                        });
                        if(callback!=null&&typeof(callback)=="function"){
                            callback();
                        }
                    }
                }, () => {})
            }else if(type==2){
                this.$api.listProductSpecByWare({ware:val,limit:40}).then(res => {
                    if(res.data.code==1){
                        res.data.data.data.forEach(e => {
                            let obj = {
                                pid:e.id,
                                spid:e.sid,
                                number:e.number,
                                name:e.name,
                                price:e.price,
                                unit:e.packing,
                                inter:e.inter,
                                spec:e.spec1+e.spec2,
                                stocknum:e.amount,
                            }
                            this.mpList.push(obj);
                        });
                        if(callback!=null&&typeof(callback)=="function"){
                            callback();
                        }
                    }
                }, () => {})
            }else if(type==3){
                this.$api.listProductSpec({page:1,limit:40}).then(res=>{
                    if(res.data.code==1){
                        res.data.data.data.forEach(e => {
                            if(!e.spec1){
                                e.spec1 = "";
                            }
                            if(!e.spec2){
                                e.spec2 = "";
                            }
                            let obj = {
                                pid:e.id,
                                spid:e.sid,
                                number:e.number,
                                name:e.name,
                                price:e.price,
                                unit:e.packing,
                                inter:e.inter,
                                spec:e.spec1+e.spec2,
                                stocknum:e.amount,
                            }
                            this.mpList.push(obj);
                        });
                        if(callback!=null&&typeof(callback)=="function"){
                            callback();
                        }
                    }
                })
            }
            
        },
        chooseMSpecs(e,row){
            row.price = e.price;
            row.unit = e.unit;
            row.pid = e.pid;
            row.spid = e.spid;
            row.name = e.number +' '+e.name +e.spec;
            row.inter = e.inter;
            row.stocknum = e.stocknum;
            if(e.inter==1){
                row.count = parseInt(row.count);
            }
            row.pname = "";
            row.mproductEdit = false;
        },
        ////////////产品相关/////////////
        getProduct() {
            this.$api.listProduct().then(res => {
                if(res.data.code==1){
                    res.data.data.forEach(e => {
                        if(e.specs.length>0){
                            e.specs.forEach(s=>{
                                let obj = this.getProductObj(e,s);
                                this.productList.push(obj);
                            })
                        }
                    });
                }
            }, () => {})
        },
        productMany(row) {
            this.productListDialog = true;
            this.curRow = row;
        },
        proSelected(){
            this.cload = true;
            this.$nextTick(() => {
                this.$refs.proList.selectProduct();
            });
        },
        closeProductList(arr){
            if(arr[0].length>0){
                let postarr = [];
                arr[0].forEach(e=>{
                    e.specs.forEach(s=>{
                        if(s.count>0||s.num>0){
                            let pro = this.getProductObj(e,s);
                            let row = this.addRow(this.curRow);
                            row.num = s.num;
                            row.count = s.count;
                            this.chooseSpecs(pro,row);
                        }
                    })
                })
                if(!(this.curRow.pid>0)){
                    this.removeRow(this.curRow);
                }
                this.curRow = {};
                this.productListDialog = false;
                this.cload = false;
            }
        },
        getProductObj(e,s){
            let obj = {
                color:s.color,
                spid:s.id,
                size:s.size,
                number:e.number,
                name:e.name,
                pid:e.id,
                spec:e.spec,
                price:s.price,
                unit:s.unit,
            }
            return obj;
        },
        chooseSpecs(e,row){
            row.spec = e.color+"/"+e.size;
            row.price = e.price;
            row.unit = e.unit;
            row.pid = e.pid;
            row.spid = e.spid;
            row.name = e.name;
            row.pname = e.name;
            row.number = e.number;
            row.productEdit = false;
            if(this.wareHouseModel){
                if(!row.store){
                    row.store = this.wList[0].id;
                }
                this.$api.getSpecStock({pid:e.pid,spid:e.spid}).then(res=>{
                    if(res.data.code==1){
                        let obj = {}
                        res.data.data.forEach(s=>{
                            obj[s.id] = {
                                stock:s.stock,
                                negative:s.negative,
                                name:s.name,
                                stDesc:this.$common.changeSendDesc(s.stock,e.unit),
                            };
                        })
                        row.stockList = obj;
                        if(row.store>0){
                            row.storename = row.stockList[row.store].name;
                            row.stock = row.stockList[row.store].stock;
                            row.stDesc = row.stockList[row.store].stDesc;
                            row.negative = row.stockList[row.store].negative;
                        }
                        this.$forceUpdate();
                    }
                })
            }
        },
    }
}
</script>


<style scoped>
.errstyle{
    color: #ff0000;
}
.productList {
    position: absolute;
    right: 20px;
    height: 34px;
    line-height: 34px;
    background: #fff;
    top: 11px;
}
.ddname{
    font-size: 12px;
    padding:3px 5px;
    border-radius: 5px;
    border:1px solid #dcdfe6;
}
</style>